<div class="row">
  <div class="left">
    <div class="chip" [ngClass]="{
      'red': type === 'Dropped',
      'green': type === 'Proxy',
      'yellow': type === 'Directly'
    }">
      {{type}}
    </div>
    <div class="text">{{name}}</div>
  </div>
</div> 